import { NgModule } from '@angular/core';
import { PlatformModule } from '@app/platform.module';
import { TableModule } from '../table/table.module';
import { AsyncSystemTasksRouterModule } from './async-system-tasks.routes';
import { AsyncSystemTasksIndexTable } from './services/async-system-tasks-index.table';
import { AsyncSystemTasksIndexView } from './views/index/index.view';

@NgModule({
    imports: [AsyncSystemTasksRouterModule, TableModule, PlatformModule],
    declarations: [AsyncSystemTasksIndexView],
    providers: [AsyncSystemTasksIndexTable],
})
export class AsyncSystemTasksModule {}
